<script lang="ts" setup>
import { computed, Ref, ref, watch } from "vue";
import Gallery, {
  GalleryInstance,
  GenMedia,
} from "@/components/mobile/media/Gallery.vue";
import { useMateTrait } from "@/stores/mateTrait";
import LightArrowIcon from "@/components/icon/LightArrowIcon.vue";
import { useMate } from "@/stores/mate";
import { GenGalleryInstance } from "@/components/mobile/media/GenGallery.vue";
import { showSuccessToast } from "vant";
import i18n from "@/locales";
import { getInitTraitPromptJson } from "@/modules/common";
import { useUI } from "@/stores/ui";
// 1. 常量
// 2. Props & Emit & Expose
export interface PortraitGalleryInstance extends GenGalleryInstance {
  selectedPortraitList: Ref<MatePortrait[]>;
}

const activePortrait = ref<MatePortrait | undefined>({
  promptJson: getInitTraitPromptJson(),
});
const props = withDefaults(
  defineProps<{
    filter?: 1 | 2; // 1-图片；2-视频
    selectable?: boolean;
    enableUpload?: boolean;
    maxSelectCount?: number;
    enableMateChange?: boolean;
    traitId?: number;
  }>(),
  {
    selectable: false,
    enableUpload: false,
    maxSelectCount: 1,
    enableMateChange: true,
  }
);

const emit = defineEmits<{
  (e: "back"): void;
  (e: "onConfirm"): void;
}>();
// 3. 内部状态
const mateTrait = useMateTrait();
const mate = useMate();
const mediaList = computed(() => {
  let saveMap = {} as Record<number, boolean>;
  let list = [] as Media[];
  mateTrait.portraitList.forEach((v) => {
    if (!v.mediaId || !v.media || saveMap[v.mediaId]) return;
    list.push(v.media!);
    saveMap[v.mediaId] = true;
  });
  return list;
});
const mediaId2PortraitMap = computed<Map<number, MatePortrait>>(() => {
  const map = new Map<number, MatePortrait>();
  mateTrait.portraitList
    .filter((item) => item.media)
    .forEach((item) => {
      if (item.media) map.set(item.mediaId!, item);
    });
  return map;
});

const galleryRef = ref<GalleryInstance | null>(null);
// const showMateSelect = ref(false);
const showPortraitCreate = ref(false);
const currentMateId = ref(mate.currentMate!.id);
const currentMate = computed(() => mate.getMyMateById(currentMateId.value!));
const loading = ref(false);
const showCreatePortrait = computed(() => mateTrait.traitList.length > 0);

defineExpose<PortraitGalleryInstance>({
  clear: (clearFilter?: boolean) => {
    galleryRef.value!.clear(clearFilter);
  }, // method: 刷新gallery列表
  selectedMediaList: computed(
    () => galleryRef.value?.selectedMediaList as GenMedia[]
  ), // computed: 已选中的媒体列表
  selectedPortraitList: computed(
    () =>
      galleryRef.value?.selectedMediaList.map((item) =>
        mediaId2PortraitMap.value.get(item.id!)
      ) as MatePortrait[]
  ),
});

// watch(currentMateId, () => {
//   mateTrait.portraitList = [];
//   galleryRef.value?.clear();
// });
// Event Handler
const uiStore = useUI();
const onMateChange = () => {
  if (props.enableMateChange) {
    // showMateSelect.value = true;
    uiStore.popMateSelector({
      switchMate: false,
      callback: (mate) => {
        currentMateId.value = mate.id;
        galleryRef.value?.clear();
      },
    });
  }
};

const fetchList = async () => {
  const data = await mateTrait.getOrFetchPortraitList(
    props.traitId,
    30,
    currentMateId.value
  );
  return data.length >= 30;
};

const onPortraitSave = async (params: any) => {
  try {
    showSuccessToast(i18n.global.t("Message.saveSuccess"));
    mateTrait.portraitList = [];
    galleryRef.value?.clear();
  } finally {
  }
};
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr]">
    <div class="navbar bg-base-100 h-top-nav border-b">
      <!-- 左 -->
      <div class="navbar-start h-full">
        <button class="btn btn-ghost" @click="emit('back')">
          <light-arrow-icon />
        </button>
      </div>
      <div class="navbar-center cursor-pointer" @click="onMateChange">
        <div>
          {{ currentMate?.name }}
          <i v-if="enableMateChange" class="iconfont icon-down1 text-sm"></i>
        </div>
      </div>
      <div class="navbar-end flex gap-1">
        <button
          v-if="showCreatePortrait"
          class="btn btn-xs rounded"
          @click="showPortraitCreate = true"
        >
          {{ $t("Buttons.createPortrait") }}
        </button>
        <button
          :disabled="galleryRef?.selectedMediaList.length === 0"
          class="btn btn-primary btn-xs rounded"
          @click="emit('onConfirm')"
        >
          {{ $t("Buttons.confirm") }}
        </button>
      </div>
    </div>
    <div class="h-full overflow-hidden relative">
      <gallery
        ref="galleryRef"
        :media-list="mediaList"
        :on-scroll-load="fetchList"
        v-bind="props"
      />
      <div
        v-show="loading"
        class="top-0 left-0 right-0 bottom-0 flex w-full h-full items-center justify-center absolute bg-base-100"
      >
        <span class="loading"></span>
      </div>
    </div>
    <!-- <MateSelect v-model:mate="currentMateId" v-model:show="showMateSelect" /> -->

    <ImageModalPortrait
      v-model:show="showPortraitCreate"
      :enableSelectionLock="false"
      :req-data="activePortrait!.promptJson"
      @saved="onPortraitSave"
    />
  </div>
</template>
